import { Selector } from '@ngrx/store';
import { OperatorFunction } from 'rxjs';
import { NgrxStore } from '../decorators.module';

// from store.d.ts
export function Select<A, B>(mapFn: Selector<A, B>): (target: any, name: string) => void;
export function Select<A, B, C>(mapFn: Selector<A, B>, op1: OperatorFunction<B, C>): (target: any, name: string) => void;
export function Select<A, B, C, D>(mapFn: Selector<A, B>, op1: OperatorFunction<B, C>, op2: OperatorFunction<C, D>): (target: any, name: string) => void;
export function Select<A, B, C, D, E>(mapFn: (state: A) => B, op1: OperatorFunction<B, C>, op2: OperatorFunction<C, D>, op3: OperatorFunction<D, E>): (target: any, name: string) => void;
export function Select<A, B, C, D, E, F>(mapFn: Selector<A, B>, op1: OperatorFunction<B, C>, op2: OperatorFunction<C, D>, op3: OperatorFunction<D, E>, op4: OperatorFunction<E, F>): (target: any, name: string) => void;
export function Select<A, B, C, D, E, F, G>(mapFn: Selector<A, B>, op1: OperatorFunction<B, C>, op2: OperatorFunction<C, D>, op3: OperatorFunction<D, E>, op4: OperatorFunction<E, F>, op5: OperatorFunction<F, G>): (target: any, name: string) => void;
export function Select<A, B, C, D, E, F, G, H>(mapFn: Selector<A, B>, op1: OperatorFunction<B, C>, op2: OperatorFunction<C, D>, op3: OperatorFunction<D, E>, op4: OperatorFunction<E, F>, op5: OperatorFunction<F, G>, op6: OperatorFunction<G, H>): (target: any, name: string) => void;
export function Select<A, B, C>(mapFn: Selector<A, B>, ...ops: OperatorFunction<B, C>[]): (target: any, name: string) => void;


export function Select<A, B>(
  mapFn: ((state: A) => B),
  ...operations: OperatorFunction<any, any>[]
) {
  return function (target: any, propertyKey: string): void {
    if (typeof mapFn !== 'function') {
      throw new TypeError(
        `Unexpected type '${typeof mapFn}' in select operator, expected 'function'`
      );
    }

    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);

    if (delete target[propertyKey]) {
      Object.defineProperty(target, propertyKey, {
        ...descriptor,
        get() {
          const store = NgrxStore.store;

          if (store === null) {
            throw new Error(`${NgrxStore.name} not connected to store!`);
          }

          const source$ = store.select(mapFn);

          return source$.pipe(...operations as [any]);
        },
        set: () => ({}),
      });
    }
  };
}
